import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

export const Route = createFileRoute("/_authenticated/reports/ticket-register")({
  component: () => (
    <div className="space-y-3">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          Legacy breakdown work orders created before the Unified Ticketing System remain visible under Work Orders → Breakdowns. All new issues are recorded here.
        </AlertDescription>
      </Alert>
      <TicketReport
        id="R-44"
        title="Ticket Register"
        description="Complete register of all tickets."
        enabledFilters={["branch", "department", "asset", "status", "priority", "source", "coverage", "sla", "dateRange"]}
        filename="ticket-register"
      />
    </div>
  ),
});

